export const worker = {
  start() {},
};
